<template>
  <div class="profile">
    <div
      class="image-button animated"
      @click="handleClick"
      >
      <img
        :ref="image"
        v-lazy="image"
        class="profile-image"
        >
    </div>
    <div
      class="text-button animated"
      :type="buttonType"
      @click="handleClick"
      >
      <div class="text-button__inner-text">
        {{ this.buttonText }}
      </div>
    </div>
  </div>
</template>

<script>
import { getRandomInt } from '@/libraries/util/random'

export default {
  name: 'ProfileView',
  props: ['buttonText', 'image', 'frame', 'showChevron', 'buttonType', 'angle'],
  mounted () {
    this.setAngle(this.$el)
  },
  methods: {
    handleClick: function () {
      this.$emit('click')
    },
    setAngle: function (el) {
      var angle = this.angle

      if (!this.angle || this.angle === 'none') {
        console.log('Not randomizing angle.')
        return
      }

      if (this.angle === 'random') {
        angle = (getRandomInt(-8, 8))
        // console.log('Angle: ' + angle)
      }

      const transformString = 'rotate(' + angle + 'deg) ' + el.style.transform
      // console.log('Transform: ' + transformString)
      el.style.transform = transformString
    },
  },
}
</script>

<style scoped>

.profile {
  width: 100px;
  margin-top: 10px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.profile-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
  object-fit: cover;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  border: 2px #fff solid;
}

.profile .image-button {
  border-radius: 50%;
  height: 88px;
  width: 88px;
  padding: 0;
  margin: 0;
  z-index: 10;
}

.profile .text-button {
  margin: 0;
  margin-top: -5px;
  font-weight: bold;
  color: #000000;
  opacity: 1.0;
}

.text-button__inner-text {
  display: inline-block;
  width: auto;
  white-space: nowrap;
  text-align: center;
}

.profile:hover .image-button {
  transform: scale(1.5) translateY(7px);
  border: 1px rgba(0, 0, 0, 0.15) solid;
}

.profile:hover .text-button {
  opacity: 0.15;
}

.animated {
  -webkit-transition: all 500ms cubic-bezier(0.685, 0, 0.400, 1); /* older webkit */
  -webkit-transition: all 500ms cubic-bezier(0.685, -0.600, 0.400, 1.650);
  -moz-transition: all 500ms cubic-bezier(0.685, -0.600, 0.400, 1.650);
  -o-transition: all 500ms cubic-bezier(0.685, -0.600, 0.400, 1.650);
  transition: all 500ms cubic-bezier(0.685, -0.600, 0.400, 1.650); /* custom */

  -webkit-transition-timing-function: cubic-bezier(0.685, 0, 0.400, 1); /* older webkit */
  -webkit-transition-timing-function: cubic-bezier(0.685, -0.600, 0.400, 1.650);
  -moz-transition-timing-function: cubic-bezier(0.685, -0.600, 0.400, 1.650);
  -o-transition-timing-function: cubic-bezier(0.685, -0.600, 0.400, 1.650);
  transition-timing-function: cubic-bezier(0.685, -0.600, 0.400, 1.650); /* custom */
}

</style>
